<!--
/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software; you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with this program;
 * if not, write to the Free Software Foundation, Inc., 51 Franklin Street, Fifth Floor,
 * Boston, MA  02110-1301, USA
 */
 -->

<template>
  <base-widget
    icon="file-earmark-text-fill"
    :empty="false"
    :loading="false"
    :title="$t('dashboard.company_rules')"
  >
    <template
      v-if="$can.update('dashboard_employees_on_leave_today_config')"
      #action
    >
      <oxd-icon
        class="orangehrm-leave-card-icon"
        name="gear-fill"
        @click="onClickConfig"
      />
    </template>
    <div class="orangehrm-company-rules-widget">
      <oxd-card class="orangehrm-company-rules-card">
        <oxd-card-body>
          <div class="orangehrm-company-rules-content">
            <oxd-icon
              icon-type="svg"
              name="file-earmark-pdf-fill"
              class="orangehrm-company-rules-icon"
            />
            <oxd-text tag="h6" class="orangehrm-company-rules-title">
              {{ $t('dashboard.company_rules_pdf') }}
            </oxd-text>
            <oxd-text tag="p" class="orangehrm-company-rules-description">
              {{ $t('dashboard.company_rules_description') }}
            </oxd-text>
            <oxd-button
              display-type="secondary"
              size="medium"
              class="orangehrm-company-rules-download-btn"
              label="Download"
              :icon-name="'download'"
              @click="downloadCompanyRules"
            >
            </oxd-button>
          </div>
        </oxd-card-body>
      </oxd-card>
    </div>
  </base-widget>
</template>

<script>
import BaseWidget from '@/orangehrmDashboardPlugin/components/BaseWidget.vue';
import {OxdIcon} from '@ohrm/oxd';
import {navigate} from '@/core/util/helper/navigation';

export default {
  name: 'CompanyRulesWidget',

  components: {
    'base-widget': BaseWidget,
    'oxd-icon': OxdIcon,
  },

  methods: {
    downloadCompanyRules() {
      // Create a temporary link element to trigger download
      const link = document.createElement('a');
      link.href = `${window.appGlobal.baseUrl}/dashboard/viewCompanyRules/id/1`;
      link.target = '_blank';

      // Append to body, click, and remove
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    onClickConfig() {
      navigate('/admin/companyRules');
    },
  },
};
</script>

<style lang="scss" scoped>
.orangehrm-company-rules-widget {
  height: 100%;
  display: flex;
  flex-direction: column;

  .orangehrm-company-rules-card {
    border: 1px solid var(--oxd-interface-gray-lighten-2-color);
    border-radius: 8px;
    transition: all 0.3s ease;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;

    &:hover {
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      transform: translateY(-2px);
    }
  }

  :deep(.oxd-card-body) {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .orangehrm-company-rules-content {
    text-align: center;
    padding: 1rem;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .orangehrm-company-rules-icon {
    font-size: 3rem;
    color: var(--oxd-interface-danger-color);
    margin-bottom: 1rem;
  }

  .orangehrm-company-rules-title {
    margin-bottom: 0.5rem;
    color: var(--oxd-interface-gray-darken-1-color);
  }

  .orangehrm-company-rules-description {
    color: var(--oxd-interface-gray-color);
    margin-bottom: 1.5rem;
    font-size: 0.875rem;
  }

  .orangehrm-company-rules-download-btn {
    min-width: 120px;

    .oxd-icon {
      margin-right: 0.5rem;
    }
  }
}
</style>
